import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUsers } from '../reduxLogic/reducers/auth/getAllUsersSlice';

// Employee ID (the same value the Reporting Mapping tab shows) is not part of the
// advances / advance requests / supervisors responses, so look it up by user id from
// the users list that is already loaded into redux for the admin portal.
// Returns a function: empIdFor(userId) -> employee id string, or '' when unknown.
const useEmployeeIds = () => {
  const dispatch = useDispatch();
  const { allUsers = [] } = useSelector((state) => state.allUsers || {});

  useEffect(() => {
    if (!allUsers || allUsers.length === 0) {
      dispatch(getAllUsers());
    }
  }, [dispatch, allUsers]);

  const byId = useMemo(() => {
    const map = new Map();
    (allUsers || []).forEach((u) => {
      const id = String(u?._id || u?.id || u?.userInfo?._id || '');
      const emp = u?.employee_id || u?.userInfo?.employee_id || u?.employeeId || '';
      if (id && emp) map.set(id, String(emp));
    });
    return map;
  }, [allUsers]);

  return (userId) => (userId ? byId.get(String(userId?._id || userId)) || '' : '');
};

export default useEmployeeIds;
